// App per iPhone/Android (Capacitor): la WebView carica https://notflix.it, quindi
// questo è lo stesso bundle del sito. Qui solo i ritocchi che servono dentro l'app;
// nel browser Capacitor.isNativePlatform() è falso e non succede niente.

import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';

export const isNativeApp = Capacitor.isNativePlatform();

if (isNativeApp) {
    document.documentElement.dataset.native = Capacitor.getPlatform();
}

// Testo della barra di stato leggibile su entrambi i temi: chiaro sul tema scuro,
// scuro sul tema chiaro.
export function syncNativeSystemBars(isDark) {
    if (!isNativeApp) return;
    SystemBars.setStyle({ style: isDark ? SystemBarsStyle.Dark : SystemBarsStyle.Light })
        .catch(() => {});
}
